<template>
  <div class="wrapper">
    <div class="fade_out_intro"></div>
    <hero></hero>

    <main class="main">
      <information></information>

      <figure class="section--full_image">
        <img src="/static/img/img01.jpg" alt="行き場のない二人は、家族になった">
      </figure>

      <introduction></introduction>
      <story></story>

      <div class="section">
        <figure class="section--full_image">
          <img src="/static/img/collage.jpg" alt="行き場のない二人は、家族になった">
        </figure>
      </div>

      <casts></casts>
      <staff></staff>
      <director></director>
      <writer></writer>
      <theme-song></theme-song>
      <comments></comments>

      <figure class="section--full_image">
        <img src="/static/img/theater-img.jpg" alt="行き場のない二人は、家族になった">
      </figure>

      <theaters></theaters>

      <figure class="section--full_image">
        <img src="/static/img/footer.jpg" alt="行き場のない二人は、家族になった">
      </figure>
    </main>

    <footer-tag></footer-tag>
  </div>
</template>

<script>
import Vue from 'vue'
import Hero from '@/components/Hero'
import Information from '@/components/Information'
import Introduction from '@/components/Introduction'
import Story from '@/components/Story'
import Casts from '@/components/Casts'
import Staff from '@/components/Staff'
import Director from '@/components/Director'
import Writer from '@/components/Writer'
import Themesong from '@/components/Themesong'
import Comments from '@/components/Comments'
import Theaters from '@/components/Theaters'
import Footer from '@/components/Footer'

Vue.component('hero', Hero)
Vue.component('information', Information)
Vue.component('introduction', Introduction)
Vue.component('story', Story)
Vue.component('casts', Casts)
Vue.component('staff', Staff)
Vue.component('director', Director)
Vue.component('writer', Writer)
Vue.component('theme-song', Themesong)
Vue.component('comments', Comments)
Vue.component('theaters', Theaters)
Vue.component('footer-tag', Footer)

export default {
  name: 'Home',
  metaInfo: {
    title: '映画『名前』公式HP'
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue